import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  stepperKickerLabel: {
    id: "funding-application: stepper label",
    defaultMessage: "Step {currentStep} of {totalSteps}",
    description: "e.g. Step 5 or 7; to show customer where they are in the application process",
  },
});

export const BUTTON_MESSAGES = defineMessages({
  platformsButton: {
    id: "funding-application: platforms button",
    defaultMessage: "Platforms",
  },
  documentsButton: {
    id: "funding-application: documents button",
    defaultMessage: "Documents",
  },
  softCreditCheckButton: {
    id: "funding-application: soft credit check button",
    defaultMessage: "Soft credit check",
  },
  submitApplicationButton: {
    id: "funding-application: submit application button",
    defaultMessage: "Submit application",
  },
  continueLabel: {
    id: "funding-application:Continue",
    defaultMessage: "Continue",
  },
  documentUploadSusa: {
    id: "funding-application: SUSA document name",
    defaultMessage: "SUSA",
  },
  documentUploadPoolBancario: {
    id: "funding-application: Pool Bancario document name",
    defaultMessage: "Pool Bancario",
  },
  documentUploadRevenueForecast: {
    id: "funding-application: revenue projections document name",
    defaultMessage: "Revenue Projections",
  },
  documentUploadDebtAgreement: {
    id: "funding-application: debt agreement document name",
    defaultMessage: "Debt agreements",
  },
  documentUploadManagementAccounts: {
    id: "funding-application: management accounts document name",
    defaultMessage: "Management accounts",
  },
  documentUploadProfitAndLoss: {
    id: "funding-application: profit and loss document name",
    defaultMessage: "Profit and Loss Statement",
  },
  documentUploadBalanceSheet: {
    id: "funding-application: balance sheet document name",
    defaultMessage: "Balance Sheet",
  },
  bankingButton: {
    id: "funding-application: banking back button",
    defaultMessage: "Bank accounts",
  },
  bankStatementsButton: {
    id: "funding-application: bank statements back button",
    defaultMessage: "Bank statements",
  },
  applicationOverviewButton: {
    id: "funding-application: application overview back button",
    defaultMessage: "Application overview",
  },
});
